var map = {
	"./adventurealtitude.jpg": "efd7",
	"./garden.jpg": "69a6",
	"./pigduck.jpg": "6b07",
	"./rain.jpg": "63df",
	"./spices.jpg": "4f85",
	"./sunset.jpg": "4ff1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0a81";